<template>
    <div class="detail-container">
        <div class="nav-top">
            <span class="one one-notebook"></span>
            <span v-for="(item,index) in breadcrumb" class='normal'
                  @click="navItemClick(item,index===(breadcrumb.length-1))">
                {{item.name}}
                <span v-if="index!=(breadcrumb.length-1)" class="one one-arrow-right"> </span>
            </span>
        </div>
        <div :class="'class-item'+(params.type==='productManual'?' product':'')">
            <div v-if="params.type==='productManual'">
                <div class="image-container" @click="viewPdf(detail)">
                    <img :src="detail.cover"
                         class="class-cover"/>
                </div>
                <div class="right-info">
                    <div class="class-title" v-html="detail.title"></div>
                    <div class="other-info-container">
                        <div class="main-info" v-if="detail.introductionAuthor">
                            <label class="main-info-item">
                                <span class="one one-firm"></span>
                                <span>{{JSON.parse(detail.introductionAuthor||'[]').join(';')}}  </span>
                            </label>
                        </div>
                        <div class="main-info" v-if="detail.timeInfo">
                            <label class="main-info-item">
                                <span class="one one-icon-copy-line"></span>
                                <span>本手册共{{detail.timeInfo}}页 </span>
                            </label>
                        </div>
                        <div class="class-other-info">
                            <div class="download-container">
                                <button class="file-download right" @click="viewPdf(detail)">
                                    <span class="one one-zoom-in"></span>
                                    在线预览
                                </button>
                                <button class="file-download right normal" @click="annexDownload(detail)">
                                    <span class="one one-download"></span>
                                    下载文件
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div v-if="params.type==='liveCourse'" class="live-course">
                <div class="class-title" v-html="detail.title"></div>
                <div class="live-info">
                    <img :src="detail.cover" @click="goDetail(detail)"
                         class="class-cover"/>
                    <div class="right-info">
                        <div class="other-info-container">
                            <div class="main-info">
                                <label class="main-info-item" v-if="detail.introductionAuthor">
                                    <span class="one one-firm"></span>
                                    <span>{{JSON.parse(detail.introductionAuthor||'[]').join(';')}} </span>
                                </label>

                                <label class="main-info-item" v-if="detail.timeInfo">
                                    <span class="one one-clock"></span>
                                    <span>课程时长约{{detail.timeInfo}}小时</span>
                                </label>
                            </div>
                            <div class="class-other-info">
                                <div class="download-container">
                                    <button class="file-download right" @click="goDetail(detail)">
                                        <span class="one one-zoom-in"></span>
                                        在线播放
                                    </button>
                                    <Poptip :visible.sync="downFilesShow" placement="bottom">
                                        <div slot="content">
                                            <div class="files">

                                                <div class="file" v-for="coursesFile in coursesFiles"
                                                     :title="coursesFile.name" @click="downloadClassFile(coursesFile)">
                                                    <VuiIco :class="['ico-left', coursesFile.icoClassName]"></VuiIco>
                                                    {{coursesFile.name}}
                                                </div>
                                            </div>
                                        </div>
                                        <button class="file-download right normal" @click="getClassFiles(detail)">
                                            <span class="one one-download"></span>
                                            下载课件
                                        </button>
                                    </Poptip>

                                </div>
                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>
        <Relation :content="detail.suggestion"/>
        <div class="new-detail-info" style="float: left">
            <SectionContent :title="item.title" :icon="item.type==='content'?'one-smart':'one-new-archive'"
                            :contents="item.texts"
                            v-for="item in JSON.parse(detail.introductionContent||'{}')"></SectionContent>
            <TemplateContainer :content="JSON.parse(detail.introductionProject||'{}')"></TemplateContainer>
            <ProductBookContainer :content="detail.relation"/>
            <MoreMessage :title="params.type==='productManual'?'更多须知':'拓展'"></MoreMessage>
            <HowToMake v-if="params.type==='productManual'"/>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
    import file from '@/api/file'
    import _ from 'lodash'
    import storage from '@/plugins/storage'
    import api from '@/api/calss-search'
    import EntCourseItem from "../components/EntCourseItem";
    import ClassSearchResult from "../components/ClassSearchResult";
    import Empty from "../../class-search-result/empty"
    import SectionContent from "./SectionContent"
    import TemplateContainer from "./TemplateContainer"
    import ProductBookContainer from "./ProductBookContainer"
    import MoreMessage from "./MoreMessage"
    import HowToMake from "./HowToMake"
    import Relation from "./Relation"
    import {getIcoClassByFileName} from '@/utils'

    export default {
        name: "DetailContainer",
        data() {
            return {
                token: storage.get('token'),
                downFilesShow: false,
                detail: {
                    introductionProject: '{}',
                    introductionContent: '{}',
                    relation: [],
                    suggestion: []
                },
                loading: false,
                params: this.$router.currentRoute.query,
                filterParams: {
                    query: this.$router.currentRoute.query.keyword,
                    pageIndex: 1,
                    pageSize: 9,
                    searchNumberType: 1,
                    searchType: 'course',
                    secondType: 'bigDataReport'
                },
                classListInfo: {
                    results: [],
                    courseTotal: 0,
                },
                breadcrumb: [],
                totalCount: 0,
                searchTitle: '',
                pageIndex: 0,
                courses: [],
                coursesFiles: []
            }
        },
        watch: {
            $route(to, from) {
                this.filterParams.query = this.$router.currentRoute.query.keyword
                this.filterParams.pageIndex = 1
                this.filterParams.pageSize = 9
                this.initNav()
            }
        },
        components: {
            EntCourseItem,
            Empty,
            ClassSearchResult,
            SectionContent,
            TemplateContainer,
            ProductBookContainer,
            MoreMessage,
            HowToMake,
            Relation
        },
        methods: {
            navItemClick(item, flag) {
                const {keyword, pageIndex} = this.$router.currentRoute.query
                if (flag) {
                    return
                }
                if (item.search) {
                    this.$router.back()
                } else {
                    this.$router.push(`/service-center/${this.$router.currentRoute.query.currentRoute}?keyword=${keyword}&pageIndex=${pageIndex}`)
                }
            },
            viewPdf(item) {
                const url = window.origin + `/pdf/pdf-viewer/viewer.html?url=${JSON.parse(item.productManualUrl).url}`
                window.open(url)
            },

            productManualDetail() {
                this.loading = true
                let {id} = this.$router.currentRoute.query
                api.productManualDetail(null, {paths: {id}}).then(res => {
                    res.suggestion=_.uniqBy(res.suggestion||[],'id')
                    this.detail = res
                    this.loading = false
                    this.initNav()
                })
            },

            liveCourseDetail() {
                let {id} = this.$router.currentRoute.query
                this.loading = true
                api.liveCourseDetail(null, {paths: {id}}).then(res => {
                    res.suggestion=_.uniqBy(res.suggestion||[],'id')
                    this.detail = res
                    this.loading = false
                    this.initNav()
                })
            },
            // 手册附件下载
            async annexDownload(item) {
                this.loading = true
                let downloadRes = await api.annexDownload({title: item.title, annexUrl: item.annexUrl})
                this.loading = false
                location.href = downloadRes
            },
            async getClassFiles(item) {
                this.loading = true
                this.coursesFiles = await file.getCourseFiles({}, {paths: {courseId: item.id}})
                this.loading = false
                this.coursesFiles = this.coursesFiles.map(file => {
                    return {
                        id: file.id,
                        name: file.name,
                        type: file.type,
                        urlAddress: file.urlAddress,
                        lockState: file.lockState,
                        icoClassName: getIcoClassByFileName(file.name)
                    }
                })
                if (!this.coursesFiles.length) {
                    this.$Message.info('暂无附件')
                } else {
                    this.downFilesShow = true

                }
            },
            downloadClassFile(course) {
                if (course.lockState === 1) { // 加锁状态
                    this.$Message.info(`课件将在开课后${this.course.unlockAttachmentTime}分钟后自动解锁`)
                    return
                }
                let domain = process.env.NODE_ENV === 'development' ? this.$config.courseFilesDomain : ''
                let href = `${domain}/live/api/v1/outer/file/seaFile/download/${this.detail.id}?path=${encodeURIComponent('/')}&fileName=${encodeURIComponent(course.name)}`
                if (this.token) {
                    href += `&school_token=${this.token}`
                }
                if (sessionStorage.getItem('verify-md5')) {
                    href += `&verify-md5=${sessionStorage.getItem('verify-md5')}`
                }
                window.location.href = href
            },
            goDetail(item) {
                let url = ""
                let from = `?from=${encodeURIComponent(location.hash.replace('#', ''))}`
                if (item.courseType == 1) {
                    url = location.origin + '/#/detail' + item.id + from
                } else {
                    url = location.origin + '/#/record/detail/' + item.id + from
                }
                window.open(url)
            },
            initNav() {
                let routerMap = {
                    all: '全部',
                    prodbook: '产品手册',
                    entcourse: '对企课程',
                    'corporate-template-course': '服务模版',
                    'skill-course': '技能课程',
                    'report-course': '大数据报告',
                }
                const preRouterName = this.$router.currentRoute.query.currentRoute
                if (this.filterParams.query) {
                    this.breadcrumb = [{
                        name: routerMap[preRouterName],
                        search: ''
                    }, {name: `搜索"${this.filterParams.query}"`, search: true}, {name: this.detail.title, search: ''}]
                } else {
                    this.breadcrumb = [{name: routerMap[preRouterName], search: ''}, {
                        name: this.detail.title,
                        search: ''
                    }]
                }
            }
        },
        mounted() {
            window.scrollTo(0, 0)
            this.initNav()
            if (this.$router.currentRoute.query.type === 'productManual') {
                this.productManualDetail()
            } else {
                this.liveCourseDetail()
            }
        }
    }
</script>

<style scoped lang="scss">
    .detail-container {
        width: 1000px;
        padding: 40px 0px 200px 0px;
        margin-left: 45px;

        .nav-top {
            height: 14px;
            margin-bottom: 60px;
            font-weight: 400;
            color: #B1B1B1;
            font-size: 14px;

            .one {
                font-size: 14px;
                position: relative;
                top: 2px
            }

            .normal {
                cursor: pointer;

                &:hover {
                    color: #ED6C00;
                }
            }
        }


        .class-item {
            margin-bottom: 24px;
            position: relative;
            cursor: pointer;
            width: 727px;
            display: inline-block;

            &.product {
                padding-top: 1px;

                .image-container {
                    float: left;
                    display: block;
                    text-align: center;
                }

                .class-cover {
                    float: none;
                    width: 136px;
                    height: 192px;
                    border-radius: 0;
                    position: relative;
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
                    z-index: 2;
                    left: 27px;
                    bottom: 21px;
                }

                .right-info {
                    float: left;

                    .class-title {
                        font-weight: 600;
                        margin-left: 32px;
                        font-size: 16px;
                        line-height: 22px;
                        color: #000000;
                        margin-top: 15px;
                        margin-bottom: 20px;
                    }

                    .other-info-container {
                        position: absolute;
                        padding-top: 10px;
                        width: 727px;
                        margin-left: -156px;
                        padding-left: 47px;
                        height: 150px;
                        background: #FFFFFF;
                        top: 50px;
                        box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.05);
                        border-radius: 3px;

                        .main-info {
                            margin-bottom: 16px;
                            padding-left: 140px;

                            .main-info-item {
                                margin-right: 20px;
                                font-size: 12px;
                                color: #8C8C8C;

                                .one {
                                    color: #B1B1B1;
                                    font-size: 13px;
                                    margin-right: 6px;
                                    position: relative;
                                    top: 2px
                                }
                            }
                        }

                        .class-other-info {
                            padding-left: 140px;
                        }

                        .download-container {
                            position: absolute;
                            bottom: 20px;
                            .file-download {
                                display: inline-block;
                                width: 128px;
                                height: 32px;
                                line-height: 32px;
                                background: #ED6C00;
                                box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.05);
                                border-radius: 3px;
                                font-weight: 500;
                                font-size: 12px;
                                cursor: pointer;
                                outline: none;
                                color: white;
                                border: none;
                                margin-bottom: 12px;

                                &.normal {
                                    border: 1px solid #E3E3E3;
                                    background: white;
                                    color: #686868;

                                    .one {
                                        color: #C4C4C4;
                                    }
                                }

                                .one {
                                    font-size: 14px;
                                    position: relative;
                                    top: 2px
                                }
                            }
                        }
                    }

                }
            }

            .live-course {
                width: 727px;
                .live-info {
                    width: 727px;
                    height: 150px;
                    background: #FFFFFF;
                    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.05);
                    border-radius: 3px;
                    padding: 18px;
                    position: relative;
                }

                .class-title {
                    font-weight: 600;
                    font-size: 16px;
                    color: #000000;
                    margin-bottom: 19px;
                }

                .class-cover {
                    width: 198px;
                    height: 111px;
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
                    border-radius: 0px;
                }

                .class-other-info {
                    max-width: 320px !important;
                }

                .main-info {
                    margin-bottom: 16px;

                    .main-info-item {
                        margin-right: 20px;
                        font-size: 12px;
                        color: #8C8C8C;
                        font-weight: normal;

                        .one {
                            color: #B1B1B1;
                            font-size: 13px;
                            margin-right: 6px;
                            position: relative;
                            top: 2px
                        }
                    }
                }

                .download-container {
                    position: absolute;
                    bottom: 20px;
                    .file-download {
                        display: inline-block;
                        width: 128px;
                        height: 32px;
                        line-height: 32px;
                        background: #ED6C00;
                        box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.05);
                        border-radius: 3px;
                        font-weight: 500;
                        font-size: 12px;
                        cursor: pointer;
                        outline: none;
                        color: white;
                        border: none;
                        margin-bottom: 12px;

                        &.normal {
                            border: 1px solid #E3E3E3;
                            background: white;
                            color: #686868;

                            .one {
                                color: #C4C4C4;
                            }
                        }

                        .one {
                            font-size: 14px;
                            position: relative;
                            top: 2px
                        }
                    }
                }

            }


            .class-cover {
                float: left;
                width: 206px;
                height: 115px;
                border-radius: 4px;
                cursor: pointer;
            }

            .files {
                .file {
                    height: 30px;
                    line-height: 30px;
                    width: 240px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-break: break-all;
                    .vui-ico {
                        font-size: 20px !important;
                        position: relative;
                        top:2px
                    }

                    &:hover {
                        color: #ed6c00;
                    }
                }
            }

            /deep/ .right-info {
                padding-left: 20px;
                display: inline-block;

                .class-other-info {
                    font-size: 12px;
                    font-weight: 400;
                    color: rgba(102, 102, 102, 1);
                    line-height: 17px;
                    max-width: 600px;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    max-height: 70px;
                    -webkit-line-clamp: 4;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }

                .class-title {
                    cursor: pointer;
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.5;
                    letter-spacing: normal;
                    color: #212121;
                }

                /deep/ .search-result-highlight {
                    color: #ED6C00 !important;
                }

                .class-auth {
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #666666;
                    height: 40px;
                    max-width: 600px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;
                    overflow: hidden;
                }

                .file-download {
                    line-height: 15px;
                    bottom: 0;
                    margin-right: 10px;
                    margin-top: 5px;
                }
            }
        }
    }
</style>
